import React from 'react';
import PortalService from '../../../services/portal/portal.service';
import { usePortalResource } from '../usePortalResource';
import PortalSection, { Card, EmptyState } from '../PortalSection';
import { formatClinician, formatPortalDate } from '../format';

/** Visit summaries written by clinicians (summary text only; no other chart content). */
const SummariesScreen: React.FC<{ patientId: string }> = ({ patientId }) => {
  const { data, loading, error } = usePortalResource(PortalService.getSummaries, patientId);
  return (
    <PortalSection title="Visit summaries" loading={loading} error={error}>
      {data &&
        (data.summaries.length === 0 ? (
          <EmptyState>No visit summaries yet.</EmptyState>
        ) : (
          <ul className="flex flex-col gap-3">
            {data.summaries.map((item) => (
              <li key={item.visitId}>
                <Card>
                  <article aria-labelledby={`summary-${item.visitId}`}>
                    <h2 id={`summary-${item.visitId}`} className="text-base font-semibold text-slate-900">
                      {formatPortalDate(item.visitDate)} · {item.discipline}
                    </h2>
                    <p className="text-sm text-slate-700">By {formatClinician(item.clinician)}</p>
                    <p className="mt-2 whitespace-pre-wrap text-slate-800">{item.summary}</p>
                  </article>
                </Card>
              </li>
            ))}
          </ul>
        ))}
    </PortalSection>
  );
};

export default SummariesScreen;
